import Header from "../../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";
import { privateRequest } from "../../commonApi/CommonApi";
import { createBrowserHistory } from "history";
import { Image_URL } from "../../commonApi/CommonApi";
import { Helmet } from "react-helmet";

function AllPackages() {
  const [deletePackages, setDeletePackage] = useState([]);
  const [Package, SetPackage] = useState([]);
  const [combineData, setCombineData] = useState([]);
  const navigate = useNavigate();

  const GetPackage = async () => {
    try {
      const response = await privateRequest.get(`Package/GetPackage`);
      SetPackage(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching combine data:", error);
    }
  };

  // Function to check if all variants in package are active - accepts optional freshCombineData param
  const checkAllVariantsActiveWithData = (packageItem, freshData = null) => {
    const dataToUse = freshData || combineData;
    const inactiveServices = [];

    console.log('checkAllVariantsActiveWithData called:', {
      hasFreshData: !!freshData,
      servicesCount: packageItem?.serviceId?.length,
      addonsCount: packageItem?.AddonService?.length
    });

    // Check main services
    if (packageItem?.serviceId && Array.isArray(packageItem.serviceId)) {
      packageItem.serviceId.forEach((serviceItem, index) => {
        if (!serviceItem?.service || !serviceItem?.variant) {
          console.log(`Skipping service at index ${index}: missing service or variant`);
          return;
        }

        const serviceId = serviceItem.service?._id || serviceItem.service;
        const variantId = typeof serviceItem.variant === 'object' ? serviceItem.variant._id : serviceItem.variant;

        console.log(`Checking service ${index}:`, { serviceId, variantId });

        // ALWAYS try fresh data first
        let service = dataToUse?.newServiceId?.find(
          (s) => s._id === serviceId
        );

        // Fallback to package's populated data if service not found in combineData
        // (Inactive services are NOT returned by CombineApis, so we need this fallback)
        if (!service && serviceItem.service && typeof serviceItem.service === 'object') {
          if (serviceItem.service.ServiceName) {
            service = serviceItem.service;
            console.log('Using fallback service from package data (service was inactive)');
          }
        }

        console.log(`Service ${index} found:`, !!service, service?.ServiceName);

        if (service) {
          // ALWAYS look for variant in fresh/current service data first
          let variant = service.ServiceVarients?.find(
            (v) => v._id === variantId
          );

          console.log(`Variant found in service data:`, !!variant);

          // Fallback to package's populated variant data if not found
          // (This is needed when the service came from package data, not combineData)
          if (!variant) {
            if (serviceItem.variant && typeof serviceItem.variant === 'object') {
              variant = serviceItem.variant;
              console.log('Using variant from package populated data');
            } else if (serviceItem.service && typeof serviceItem.service === 'object' && serviceItem.service.ServiceVarients) {
              variant = serviceItem.service.ServiceVarients.find(v => v._id === variantId);
              console.log('Using variant from package service data');
            }
          }

          if (variant) {
            const variantStatus =
              variant.VarientDiscription?.[0]?.ServiceStatus;
            const isActive =
              variantStatus === true ||
              variantStatus === 1 ||
              variantStatus === "1";

            console.log(`Variant status:`, { variantStatus, isActive, variantName: variant.ServiceType?.Name });

            if (!isActive) {
              inactiveServices.push({
                serviceId: service._id,
                serviceName: service.ServiceName,
                variantId: variant._id || variantId,
                variantType: variant.ServiceType?.Name || 'Unknown',
                variantStatus: isActive ? "Active" : "Inactive",
                isActive: false,
              });
            }
          } else {
            // Variant not found anywhere - treat as inactive/unknown
            console.warn('Variant not found for service:', service.ServiceName, 'variantId:', variantId);
          }
        } else {
          console.warn('Service not found:', serviceId);
        }
      });
    }

    // Check addon services
    if (packageItem?.AddonService && Array.isArray(packageItem.AddonService)) {
      packageItem.AddonService.forEach((addonItem) => {
        if (!addonItem?.service || !addonItem?.variant) return;

        const serviceId = addonItem.service?._id || addonItem.service;
        const variantId = typeof addonItem.variant === 'object' ? addonItem.variant._id : addonItem.variant;

        // ALWAYS try fresh data first
        let service = dataToUse?.newServiceId?.find(
          (s) => s._id === serviceId
        );

        // Fallback to package's populated data if service not found in combineData
        // (Inactive services are NOT returned by CombineApis, so we need this fallback)
        if (!service && addonItem.service && typeof addonItem.service === 'object') {
          if (addonItem.service.ServiceName) {
            service = addonItem.service;
          }
        }

        if (service) {
          // ALWAYS look for variant in fresh/current service data first
          let variant = service.ServiceVarients?.find(
            (v) => v._id === variantId
          );

          // Fallback to package's populated variant data if not found
          if (!variant) {
            if (addonItem.variant && typeof addonItem.variant === 'object') {
              variant = addonItem.variant;
            } else if (addonItem.service && typeof addonItem.service === 'object' && addonItem.service.ServiceVarients) {
              variant = addonItem.service.ServiceVarients.find(v => v._id === variantId);
            }
          }

          if (variant) {
            const variantStatus =
              variant.VarientDiscription?.[0]?.ServiceStatus;
            const isActive =
              variantStatus === true ||
              variantStatus === 1 ||
              variantStatus === "1";

            if (!isActive) {
              inactiveServices.push({
                serviceId: service._id,
                serviceName: service.ServiceName,
                variantId: variant._id || variantId,
                variantType: variant.ServiceType?.Name || 'Unknown',
                variantStatus: isActive ? "Active" : "Inactive",
                isActive: false,
              });
            }
          } else {
            console.warn('Addon variant not found for service:', service.ServiceName, 'variantId:', variantId);
          }
        }
      });
    }

    return inactiveServices;
  };

  // Function to handle package status change
  const handlePackageStatusChange = async (packageItem, nextStatus) => {
    const currentStatus = packageItem?.Status === true || packageItem?.Status === 1 || packageItem?.Status === "1" ? 1 : 0;

    console.log('handlePackageStatusChange called:', { nextStatus, currentStatus, packageTitle: packageItem?.packageTitle });

    // If trying to activate package, check all variants
    if (nextStatus === 1 && currentStatus === 0) {
      console.log('Attempting to activate package, checking variants...');

      // Refresh combineData to get latest service/variant status
      let freshCombineData = combineData;
      try {
        const response = await privateRequest.get(`Service/CombineApis`);
        freshCombineData = response?.data?.data;
        setCombineData(freshCombineData);
        console.log('Fresh combineData fetched successfully');
      } catch (error) {
        console.error("Error refreshing combine data:", error);
        // Use existing combineData if refresh fails
      }

      // Use fresh data for the check
      console.log('Checking variants with fresh data...');
      const inactiveServices = checkAllVariantsActiveWithData(packageItem, freshCombineData);
      console.log('Inactive services found:', inactiveServices);

      if (inactiveServices.length > 0) {
        // Build services table for popup
        const servicesTable = inactiveServices
          .map((service) => {
            // Escape the service name for use in HTML onclick attribute
            const escapedServiceName = (service.serviceName || '').replace(/'/g, "\\'").replace(/"/g, '&quot;');
            return `
            <tr>
              <td style="padding:10px 14px; font-size:13px;">
                <strong>${service.serviceName}</strong>
                <br />
                <small style="color:#6c757d; font-size:11px;">
                  Variant: ${service.variantType || "N/A"}
                </small>
              </td>
              <td style="text-align:center;">
                <span style="
                  padding:4px 10px;
                  font-size:11px;
                  border-radius:12px;
                  color:#fff;
                  background:#dc3545;
                ">
                  Inactive
                </span>
              </td>
              <td style="text-align:center;">
                <button
                  style="
                    font-size:11px;
                    padding:4px 10px;
                    border-radius:4px;
                    border:none;
                    background:#0d6efd;
                    color:#fff;
                    cursor:pointer;
                  "
                  onclick="editService('${service.serviceId}', '${escapedServiceName}')">
                  ✏️ Edit
                </button>
              </td>
            </tr>
            `;
          })
          .join("");

        // Modal HTML (same style as EditService.js)
        const tableHTML = `
          <div style="text-align:center; margin-bottom:12px;">
            <div style="
              width:72px;
              height:72px;
              border-radius:50%;
              border:4px solid #f0ad4e;
              display:inline-flex;
              align-items:center;
              justify-content:center;
              font-size:34px;
              color:#f0ad4e;
              font-weight:700;
            ">!</div>
          </div>

          <!-- TITLE -->
          <h3 style="text-align:center; font-weight:600; margin-bottom:14px;">
            Inactive Service Variants Found
          </h3>

          <!-- WARNING BAR -->
          <div style="
            background:#fff3cd;
            border:1px solid #ffeeba;
            color:#856404;
            padding:10px 16px;
            font-size:13px;
            border-radius:6px;
            margin-bottom:14px;
            text-align:center;
          ">
            ⚠️ Package cannot be activated because some service variants are inactive.
            Please activate all service variants first.
          </div>

          <!-- TABLE CARD -->
          <div style="
            border:1px solid #dee2e6;
            border-radius:6px;
            overflow:hidden;
            background:#fff;
          ">
            <table style="width:100%; border-collapse:collapse;">
              <thead style="background:#343a40; color:#fff;">
                <tr style="height:36px; background:#343a40; color:#fff;">
                  <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:left;">
                    🔧 Service Details
                  </th>

                  <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                    ℹ️ Status
                  </th>

                  <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                    ✏️ Action
                  </th>
                </tr>
              </thead>
              <tbody>
                ${servicesTable}
              </tbody>
            </table>
          </div>

          <!-- FOOTER NOTE -->
          <div style="
            margin-top:10px;
            font-size:12px;
            color:#6c757d;
            text-align:center;
          ">
            ℹ️ Click "Edit" to navigate to the service edit page and activate the variant.
          </div>
        `;

        Swal.fire({
          icon: undefined,
          html: tableHTML,
          width: 760,
          confirmButtonText: "OK",
          allowOutsideClick: false,
          customClass: {
            confirmButton: 'swal-btn-sm',
          },
          didOpen: () => {
            // Add style for button
            const style = document.createElement('style');
            style.textContent = `
              .swal-btn-sm {
                font-size: 12px !important;
                padding: 6px 14px !important;
                border-radius: 4px !important;
                min-height: auto !important;
              }
            `;
            document.head.appendChild(style);

            window.editService = (serviceId, serviceName) => {
              Swal.close();
              // Navigate to the AllService page with search parameter
              // The service name will be searched in DataTable to filter the list
              const searchParam = encodeURIComponent(serviceName || '');
              window.open(`/service?search=${searchParam}`, "_blank");
            };
          },
        });

        return; // ⛔ BLOCK — don't update package
      }
    }

    // ✅ Safe → update package status
    try {
      const formData = new FormData();
      formData.append("packageTitle", packageItem?.packageTitle);
      formData.append("PcatId", packageItem?.PcatId?._id || packageItem?.PcatId);
      formData.append("discription", packageItem?.discription || "");
      formData.append("Status", nextStatus === 1 ? true : false);
      formData.append("packageType", packageItem?.packageType);
      formData.append("RPrice", packageItem?.RPrice || 0);
      formData.append("IsDiscription", packageItem?.IsDiscription || false);
      formData.append("SPrice", packageItem?.SPrice || 0);
      formData.append("payble", packageItem?.payble || packageItem?.payableAmount || 0);
      formData.append("discount", packageItem?.discount || 0);
      formData.append("PCgroup", packageItem?.PCgroup);

      // Handle Child Categories
      if (packageItem?.ChildId && Array.isArray(packageItem.ChildId)) {
        packageItem.ChildId.forEach((categoryId) => {
          const id = categoryId?._id || categoryId;
          if (id) {
            formData.append("ChildId[]", id);
          }
        });
      }

      // Handle Service Groups
      if (packageItem?.ServiceGroups && Array.isArray(packageItem.ServiceGroups)) {
        packageItem.ServiceGroups.forEach((groupId) => {
          const id = groupId?._id || groupId;
          if (id) {
            formData.append("ServiceGroups[]", id);
          }
        });
      }

      // Handle Services
      if (packageItem?.serviceId && Array.isArray(packageItem.serviceId)) {
        packageItem.serviceId.forEach((serviceId, index) => {
          const service = serviceId?.service?._id || serviceId?.service;
          const variant = serviceId?.variant;
          if (service) {
            formData.append(`serviceId[${index}][service]`, service);
            formData.append(`serviceId[${index}][variant]`, variant || '');
          }
        });
      }

      // Handle Addon Services
      if (packageItem?.AddonService && Array.isArray(packageItem.AddonService)) {
        packageItem.AddonService.forEach((addonServiceId, index) => {
          const service = addonServiceId?.service?._id || addonServiceId?.service;
          const variant = addonServiceId?.variant;
          if (service) {
            formData.append(`AddonService[${index}][service]`, service);
            formData.append(`AddonService[${index}][variant]`, variant || '');
          }
        });
      }

      const response = await privateRequest.put(
        `Package/UpdatePackage/${packageItem._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.data?.success || response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Package status updated successfully!",
        });
        GetPackage(); // Refresh the package list
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response?.data?.message || "Failed to update package status.",
        });
      }
    } catch (error) {
      console.error("Error updating package status:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message || "An error occurred while updating the package status.",
      });
    }
  };

  const deletePackage = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Package/DeletePackage/${_id}`
        );

        setDeletePackage(deletePackages.filter((item) => item._id !== _id));
        GetPackage();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  useEffect(() => {
    GetPackage();
    getAllDocumentData();
  }, []);

  // Refresh data when window regains focus (user comes back to this tab)
  useEffect(() => {
    const handleFocus = () => {
      console.log('Window focused - refreshing data...');
      GetPackage();
      getAllDocumentData();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return (
    <>
      {Package.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Packages</span>
                    </p>
                    <Link
                      to="/package/new"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">
                              <i className="fa fa-image"></i>
                            </th>
                            <th scope="col">Packages</th>
                            <th scope="col">Parent Cat.</th>
                            <th scope="col" style={{ width: "200px" }}>
                              Child Cat.
                            </th>
                            <th scope="col">Service Groups</th>
                            <th scope="col">Type</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Package?.map((item, index) => {
                            const packageStatus = item?.Status === true || item?.Status === 1 || item?.Status === "1" ? 1 : 0;

                            return (
                              <tr key={index}>
                                <td className="align-center">{index + 1}</td>
                                <td className="align-center">
                                  {item?.packageImage && (
                                    <img
                                      src={`${Image_URL}${item?.packageImage}`}
                                      alt="Category Image"
                                      height="100"
                                      width="100"
                                    />
                                  )}
                                </td>
                                <td className="align-center">
                                  {item?.packageTitle}
                                </td>

                                <td className="align-center">
                                  {item?.PcatId?.PCName}
                                </td>

                                <td className="align-center">
                                  <td className="align-center">
                                    {item?.ChildId.map((childCat) => (
                                      <span
                                        key={childCat._id}
                                        className="badge badge-primary mr-1"
                                      >
                                        {childCat.CCName}
                                      </span>
                                    ))}
                                  </td>
                                </td>
                                <td className="align-center">
                                  {item?.ServiceGroups.map((serviceGroup) => (
                                    <span
                                      key={serviceGroup._id}
                                      className="badge badge-primary mr-1"
                                    >
                                      {serviceGroup.GroupName}
                                    </span>
                                  ))}
                                </td>
                                <td className="align-center">
                                  {item?.packageType}
                                </td>
                                <td>
                                  <td>
                                    <span
                                      className={`badge ${item.Status.toString() === "true"
                                        ? "badge-primary"
                                        : "badge-danger"
                                        }`}
                                    >
                                      {item.Status.toString() === "true"
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                  </td>
                                </td>

                                <td className="align-center">
                                  <p className="mb-0">{item.createdBy?.name}</p>
                                  <p className="mb-0">
                                    {new Date(item.createdAt).toLocaleDateString(
                                      "en-US",
                                      {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric",
                                      }
                                    )}
                                  </p>
                                </td>
                                <td className="align-center">
                                  <div className="btn-group">
                                    <button
                                      onClick={() => {
                                        navigate("/package/edit", {
                                          state: item,
                                        });
                                      }}
                                      className="btn btn-primary btn-sm"
                                      data-toggle="modal"
                                      data-target="#childModal"
                                    >
                                      <i className="fa fa-edit"></i>
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => deletePackage(item._id)}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>

                                    {/* copy icon */}
                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => {
                                        const deeplink = `https://www.experts4u.in/service-detail/${item?.ChildId
                                          ? item?.ChildId[0]?._id
                                          : item?.ChildCatIDs?._id}/${item?.PCgroup}/${item?.PcatId?._id}/${item?.PcatId?.PCName}/${item?._id}/${item?._id}/${item?._id}/${item?._id}`.replace(/ /g, '%20');
                                        navigator.clipboard.writeText(deeplink).then(() => {
                                          Swal.fire("Copied!", "Deeplink has been copied to clipboard.", "success");
                                        }).catch((error) => {
                                          Swal.fire("Error!", "Failed to copy deeplink.", "error");
                                        });
                                      }}
                                    >
                                      <i className="fa fa-copy"></i>
                                    </button>
                                  </div>

                                  {/* Package Status Toggle */}
                                  <div className="mt-2" style={{ display: "flex", justifyContent: "center" }}>
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        checked={packageStatus === 1}
                                        onChange={(e) => {
                                          handlePackageStatusChange(
                                            item,
                                            e.target.checked ? 1 : 0
                                          );
                                        }}
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for toggle switch */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 34px;
          height: 18px;
        }

        .switch input {
          opacity: 0;
        }

        .slider {
          position: absolute;
          inset: 0;
          background-color: #ccc;
          border-radius: 20px;
          transition: 0.3s;
        }

        .slider:before {
          content: "";
          position: absolute;
          height: 14px;
          width: 14px;
          left: 2px;
          bottom: 2px;
          background-color: white;
          border-radius: 50%;
          transition: 0.3s;
        }

        input:checked + .slider {
          background-color: #28a745;
        }

        input:checked + .slider:before {
          transform: translateX(16px);
        }
      `}</style>
    </>
  );
}

export default AllPackages;
